import React, { useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  FormControlLabel,
  Switch,
  Paper,
  Divider,
} from '@mui/material';
import CommonButton from '../../Components/InputComponents/CommonButton';

const formFields = [
  'Client Name',
  'Email',
  'Contact Number',
  'Address',
  'Country',
  'Company Type',
  'Contact Person Name',
  'Contact Person Email',
  'Contact Person Number',
  'Branches',
];

const ClientFieldPrivilege = () => {
  const [secretFields, setSecretFields] = useState({});

  const handleToggle = (field) => {
    setSecretFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  return (
    <Box p={4} sx={{ fontFamily: 'Geist, sans-serif' }}>
      <Typography
         variant="h5"
         sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
         mb={3}
      >
        Client Privileges
      </Typography>

      <Paper elevation={3} sx={{ p: 3 }}>
        <Grid container sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "15px", lg: "15px", xl: "19px" },
                fontFamily: "Geist, sans-serif",
                fontWeight: 600,
              }}
            >
              Field Name
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              sx={{
                fontSize: { xs: "13px", sm: "15px", lg: "15px", xl: "19px" },
                fontFamily: "Geist, sans-serif",
                fontWeight: 600,
              }}
            >
              Is Confidential
            </Typography>
          </Grid>
        </Grid>

        <Divider />

        {formFields.map((field, index) => (
          <Grid container key={index} sx={{ py: 1, alignItems: 'center' }}>
            <Grid item xs={6}>
              <Typography sx={{
                // fontSize: { xs: "12px", sm: "15px", lg: "15px", xl: "19px" },
                fontFamily: "Geist, sans-serif",
              }}>{field}</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!secretFields[field]}
                    onChange={() => handleToggle(field)}
                    color="primary"
                  />
                }
                label=""
              />
            </Grid>
          </Grid>
        ))}
        <Grid
          container
          spacing={2}
          justifyContent={{ xs: "center", sm: "flex-end" }}
          sx={{ mt: 3 }}
        >

          <Grid item>
            <CommonButton variant="contained" customColor="#007BFF" >
              Save
            </CommonButton>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default ClientFieldPrivilege;
